var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "echo-ios-user_protocol" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `padding-top:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { title: "", "left-arrow": "" },
          on: { "click-left": _vm.closeWeb },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow01.png"),
                      alt: "",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "page-container" }, [
      _c("iframe", {
        staticClass: "iframe",
        attrs: { src: "/iframe/echo/UserProtocol.html", frameborder: "0" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }